export function obtenerMensajeError(error: any): string {

    if (error instanceof Error) {
        return error.message;
    }

    if (typeof error === 'string') {
        return error;
    }

    if (typeof error.error === 'string') {
        return error.error;
    }

    if (error.error && error.error.message) {
        return error.error.message;
    }

    if (error.message) {
        return error.message;
    }

    return 'Ocurrió un error desconocido';
}